import { isRequestMethod, RequestMethod } from '../types/api';
export const LightdashRequestMethodHeader = 'Lightdash-Request-Method';
export const LightdashVersionHeader = 'Lightdash-Version';
export const LightdashSdkVersionHeader = 'Lightdash-SDK-Version';
export const getRequestMethod = (headerValue) => isRequestMethod(headerValue) ? headerValue : RequestMethod.UNKNOWN;
//# sourceMappingURL=api.js.map